<template>
  <div id="order_history_list">
    <dd-header
      ref="menuRef"
      :headerType=2
    />
    <div id="container">
      <div id="content">
        <div class="title">
          <h2>ご注文履歴</h2>
        </div>
        <!-- ページ -->
        <dd-pager
          v-if="orderHistoryList && orderHistoryList.length > 0"
          :pageNo="pageNo"
          :dataCountPerPage="pageSaveCnt"
          :totalDataCount="orderHistoryList.length"
          @callback="paging"
        />
        <div class="history_list" v-for="(order,index) in viewList" :key="'history-' + index">
          <dd-history
            :orderData="order"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapState} from 'vuex'
import Pager from '../../components/common/Pager'
import LoadingModal from '../../components/common/LoadingModal'
import Header from '../components/common/DcHeader'
import OrderHistory from '../components/order/DcOrderHistory'

export default {
  name: 'DcOrderHistoryList',
  components: {
    'dd-header': Header,
    'dd-pager': Pager,
    'dd-history': OrderHistory,
    'dd-loading-modal': LoadingModal
  },
  props: {
  },
  data () {
    return {
      pageSaveCnt: 20,
      pageNo: 1
    }
  },
  computed: {
    ...mapState({
      orderHistoryList: state => state.orderHistoryList
    }),
    viewList: function () {
      if (!this.orderHistoryList) return
      let startIdx = (this.pageNo - 1) * this.pageSaveCnt
      let endIdx = ((this.pageNo) * this.pageSaveCnt)
      return this.orderHistoryList.filter(function (element, index) {
        return (index >= startIdx && index < endIdx)
      })
    }
  },
  methods: {
    ...mapActions({ getItemList: 'loadOrderHistoryList' }),
    paging: function (selPage) {
      this.pageNo = selPage
    }
  },
  mounted: function () {
    // this.addEventListener()
    this.$store.dispatch('loadOrderHistoryList', {reload: true})
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/input-list.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
#order_history_list {
  background: #FFFFFF;
}
.history_list {
  border: solid 1px;
  border-radius: 0.25em;
  margin:0px auto 30px auto;
  padding:30px;
  border-color: #dddddd;
  overflow: auto;
  width:600px;
  box-shadow: 0 2px 2px rgba(50, 50, 50, 0.28);
  ul {
    font-weight: bold;
    li {
      line-height: 20px;
      margin: 10px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcOrderHistoryList.vue